import React, { useState } from 'react';
import propTypes from 'prop-types';

import { Card, CardContent, Columns, Column } from 'src/ui/mui-ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  SaveChangesToast,
  ConfirmChangesModal,
  UiFieldset,
  UiInputAdapter,
  InnerLoader,
  UiSelectAdapter,
  UiDatePickerAdapter,
} from 'src/ui';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import dayjs from 'dayjs-ext';
import { NOTIFICATION_FREQUENCY, NOTIFICATION_TYPE } from '../const';

export function ScheduledTasksEditForm({
  onSubmit,
  submitting,
  hasValidationErrors,
  isDirty,
  isExpanded,
}) {
  const [confirmChangesModal, setConfirmChangesModal] = useState(false);
  const toastContainerClassName = classNames('bottom-toast-container', {
    'is-condensed': !isExpanded,
  });

  function showModal() {
    setConfirmChangesModal(true);
  }
  function hideModal() {
    setConfirmChangesModal(false);
  }

  return (
    <Card tag="form" onSubmit={onSubmit} noValidate>
      <CardContent>
        <div className={toastContainerClassName}>
          <SaveChangesToast
            message="Click the button to the right to save your changes"
            isLoading={submitting}
            isDisabled={submitting || hasValidationErrors}
            isVisible={isDirty}
            // eslint-disable-next-line react/jsx-no-bind
            onClickButton={showModal}
          />
        </div>
        <ConfirmChangesModal
          title="Scheduled Tasks"
          isActive={confirmChangesModal}
          // eslint-disable-next-line react/jsx-no-bind
          onClickCancel={hideModal}
          // eslint-disable-next-line react/jsx-no-bind
          onClickSubmit={hideModal}
        />
        <InnerLoader visible={submitting} />
        <UiFieldset title="Notification Type & Frequency" isFirst>
          <Columns>
            <Column isSize="1/2">
              <Field
                component={UiSelectAdapter}
                name="taskTypeId"
                id="notificationType"
                label="Notification Type"
                options={NOTIFICATION_TYPE}
              />
            </Column>
            <Column isSize="1/2">
              <Field
                component={UiSelectAdapter}
                name="taskFrequencyId"
                id="notificationFrequency"
                label="Notification Frequency"
                options={NOTIFICATION_FREQUENCY}
              />
            </Column>
          </Columns>
        </UiFieldset>
        <UiFieldset title="Email & Start Date" isFirst>
          <Columns isMultiline>
            <Column isSize="1/2">
              <Field
                component={UiInputAdapter}
                name="taskEmail"
                id="taskEmail"
                label="Notification Email"
              />
            </Column>
            <Column isSize="1/2">
              <Field
                component={UiDatePickerAdapter}
                name="taskLastStart"
                id="taskLastStart"
                label="Notification Start Date"
                maxDate={dayjs()
                  .startOf('day')
                  .toDate()}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                hasIcons="right"
                renderIcons={() => [
                  <span className="icon is-right" key="right-icon">
                    <FontAwesomeIcon icon={['fal', 'calendar-alt']} />
                  </span>,
                ]}
              />
            </Column>
          </Columns>
        </UiFieldset>
      </CardContent>
    </Card>
  );
}

ScheduledTasksEditForm.propTypes = {
  onSubmit: propTypes.func.isRequired,
  submitting: propTypes.bool.isRequired,
  hasValidationErrors: propTypes.bool.isRequired,
  isDirty: propTypes.bool.isRequired,
  isExpanded: propTypes.bool.isRequired,
};
